/* eslint-disable @next/next/no-img-element */
import InstantArticle from "views/articles/InstantArticle"
import BestQuranApps from "views/articles/BestQuranApps"
import Link from "next/link"
import { AppInterface } from "types/types"
import AppsListItem from "components/AppsListItem"

const AddAppollowToYourHomeScreenEN = ({ apps }: { apps: AppInterface[] }) => {
  const article = BestQuranApps["en"]
  return (
    <InstantArticle {...article}>
      <div dir="ltr" style={{ textAlign: "justify" }}>
        <p>
          Reading the Holy Quran is one of the most prominent acts of worship in
          the holy month of Ramadan among Muslims, and with the large number of
          smart phones and tablets, many Muslims have become dependent on iPhone
          and iPad applications to read the Holy Quran, because of the features
          provided by the Holy Quran applications, such as searching for words,
          interpreting verses, meanings of words, and translation for more. From
          the language and reading in the voice of many famous readers, in
          addition to the possibility of memorizing the verse that was stopped
          to complete the reading later. Therefore, in this article, we have
          collected for you a selection of the best iPhone and iPad applications
          for reading the Holy Quran, which are available for free in the
          software store.
        </p>

        <h2>Ayah</h2>
        <p>
          Combines the beauty of design and ease of use, winner of the Kuwait
          International Award In its eighth version as the best Quran
          application, among the features of the app:
        </p>
        <ol>
          <li>
            It is distinguished by its adoption of the King Fahd Complex for the
            Printing of the Noble Quran in Madinah, due to its reliability and
            proficiency.
          </li>
          <li>
            A summary of the interpretation of the Noble Quran, which is
            distinguished by its ease of expression, with what it contains of a
            brief statement of the purposes of the chapters, and an elicitation
            of the most prominent gifts of the verses, and an explanation of the
            meanings of strange vocabulary in a distinctive color.
          </li>
          <li>
            Audio clips for distinguished reciters with full support to control
            recitation from screen lock, number of repetitions, and pause timer.
          </li>
          <li>
            Fast and advanced search, which combines searching for verses and
            surah names, and even quick scrolling by page numbers.
          </li>
          <li>
            Share a verse or several verses via social networks, text or image,
            with a beautiful and distinctive output.
          </li>
          <li>
            The Quranic separator is a sign that moves with you from one verse
            to another to help you follow up on your Quranic conclusion.
          </li>
          <li>
            Jot down your notes and musings during recitation and view them all
            beautifully and sequentially, with automatic formatting of notes as
            you write them.
          </li>
          <li>Star any verse for quick access later.</li>
          <li>Renewed Quranic benefits with every visit to the application.</li>
          <li>Dark background for more comfortable reading at night.</li>
        </ol>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 706037876)} />
        </div>
        <h2>The Holy Quran App</h2>
        <p>
          Some features of the app include:
          <ol>
            <li>
              Interacting with the text of the Quran in the Ottoman script at
              the verse level, which allows the user to interact with the verses
              of the Quran instead of its pages.
            </li>
            <li>
              The advantage of listening to the verses with the possibility of
              repeating or repeating in the middle of the heard verse. The
              program also provides many reciters so that the listener can
              download any of the reciters when needed.
            </li>
            <li>
              Inclusion of a distinctive system for memorizing reading sites so
              that the reciter can select and memorize the verse for reference.
              The program also allows the user more than one indicator to return
              in different colors that allow him to multiply stamps and readings
              in an easy and beautiful way.
            </li>
            <li>
              The program provides the reader with the ability to refer to the
              interpretation or translation of any verse in real time by
              selecting the verse on the pages of the Quran.
            </li>
            <li>
              The program displays the background of the pages in multiple
              colors that allow the reader to choose the color that is
              comfortable for him. The program also allows the reader to read at
              night, which colors the background in black and white lines to
              give the reader complete comfort when reading in a low-light
              environment.
            </li>
            <li>
              The program provides the user with a report of the number of
              verses, pages, and chapters he has read, and calculates the time
              spent for that reading.
            </li>
            <li>
              The program facilitates the text search feature in the verses of
              the Quran through instant search and display of results with
              pages, in addition to the possibility of going to the page and
              shading the background of the selected verse to make it easier for
              the user to know it.
            </li>
            <li>
              The program provides many other features that help in easy and
              facilitating reading, which have been designed by professional
              designers who have won international awards in the field of user
              interface design.
            </li>
          </ol>
        </p>

        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 385990290)} />
        </div>
        <h2>Mus&apos;haf from i4islam</h2>
        <p>
          The iPhone Islam Quran is one of the first Arab and international
          applications that provided a wonderful experience while reading the
          Holy Quran with simulation of the effect of real paper when turning
          pages in the application, in addition to many common advantages
          between it and the aforementioned applications. The iPhone Islam Quran
          is characterized by freedom in choosing the Quran and interpretations
          And favorite readers, you can change the Qur’an within the
          application, as it contains a group of Qur’ans with several
          narrations. You can review the full article about the application from
          the iPhone Islam website through the following link:
        </p>
        <ul>
          <li>
            <a href="https://iphoneislam.com/2014/08/why-iphoneislam-mushaf/38269">
              The new Mus&apos;haf from i4islam
            </a>
          </li>
        </ul>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 328962407)} />
        </div>

        <br />
        <div className="card mt-4 mb-1">
          <div className="card-body">
            <div className="text-center">
              <i className="fa fa-star color-yellow-dark fa-2x mb-3 "></i>
            </div>
            <p className="color-white">
              Do you have any favorite apps for reciting and reading the Holy
              Quran on iPhone and iPad? You can share your favorite apps through
              the{" "}
              <Link href="/submit">
                <span className="text-white text-decoration-underline">
                  Submit Page
                </span>
              </Link>
            </p>
          </div>
          <div className="card-overlay bg-highlight opacity-95" />
          <div className="card-overlay dark-mode-tint" />
        </div>
      </div>
    </InstantArticle>
  )
}

export default AddAppollowToYourHomeScreenEN
